import { useState, useEffect, useCallback } from 'react';
import { getTenants } from '../services/apiService.ts';

export interface TenantDiagnostics {
  id: number;
  name: string;
  displayName?: string;
  status: string;
  billingState?: string;
  plan?: string;
  catalogPlanCode?: string | null;
  catalogPlanMapped?: boolean;
  catalogPlanSource?: string | null;
  commerciallyActive?: boolean;
  stripeCustomerId?: string | null;
  billingPriceId?: string | null;
  billingSubscriptionId?: string | null;
  billingTrialEndsAt?: string | null;
  billingUpdatedAt?: string | null;
  lastBillingCheckoutSessionId?: string | null;
  lastBillingCheckoutStatus?: string | null;
  lastBillingCheckoutStartedAt?: string | null;
  lastBillingCheckoutCompletedAt?: string | null;
  lastBillingCheckoutExpiresAt?: string | null;
  checkoutReady?: boolean;
  paidPilotBlockers?: string[];
  lastBillingWebhookType?: string | null;
  lastBillingWebhookAt?: string | null;
  lastBillingWebhookOutcome?: string | null;
  createdAt: string;
  enabledModules?: string[];
  features?: string[];
  catalogSuggestedModules?: string[];
  commercialEntitlements?: string[];
  commercialWarnings?: string[];
  branding?: {
    displayName?: string;
    logoUrl?: string;
    primaryColor?: string;
    secondaryColor?: string;
  };
}

export interface TenantRow extends TenantDiagnostics {}

export const useTenants = () => {
  const [rows, setRows] = useState<TenantRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTenants = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getTenants();
      setRows(data.content ?? data); // pageable or array
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchTenants(); }, [fetchTenants]);

  return { rows, loading, error, refetch: fetchTenants };
}; 
